/* boot */
import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store/index'
import BootstrapVue from 'bootstrap-vue'
import ErrorService from "@/services/ErrorService.js"

/* libraries */
// import BootstrapVue from 'bootstrap-vue'
import Multiselect from "vue-multiselect"
import vSelect from 'vue-select'

Vue.config.errorHandler = (err, vm, info) => ErrorService.onError(err, vm, info)
Vue.config.warnHandler = (msg, vm, trace) => ErrorService.onError(msg, vm, trace)

/* vue-toast-notification */
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
Vue.use(VueToast)

import VeeValidate, { Validator } from 'vee-validate'
const VueInputMask = require('vue-inputmask').default
import money from 'v-money'

/* components */
import IconSvg from "@/components/IconSvg"
import ModalGlobal from '@/components/ModalGlobal'
import NProgress from "@/utils/progress"
import Swal from "sweetalert2"

/* filters */
import { filterDate, filterDateHour, filterEndereco, moneyToString, maskCPF, maskCNPJ, filterHour, getPaisById } from './filters/filters'
import { uppercase as uppercaseFilterString, lowercase as lowercaseFilterString, firstLetterCapitalize } from './filters/filtersString'
import { maskMatricula } from "@/filters/filterMask"
import { estadoCivilFilter } from './filters/estadoCivil'

/* constants */
import objSwal from "@/constants/swalValues"
import { pageControl } from '@/constants/transictionsFunctions'

/* others */
import AuthInterceptor from '@/plugins/AuthInterceptor'
import dictionary from '@/utils/dictionary'
import { maxDate } from '@/utils/validation'
import  alerts from '@/utils/alerts'
import { upperCase, zeroBefore, onLeavingSelect, selectedOption } from './directives/directives'
import Keycloak from 'keycloak-js'
import '@/helpers/functions'

/* inicio - ripple */
import Ripple from "vue-material-design-ripple"
import "vue-material-design-ripple/dist/vue-material-design-ripple.css"
/* fim - ripple */

export const keycloak = new Keycloak(`${location.protocol}//${location.host}/keycloak.json`)
export function updateKeycloakToken () {
  if (keycloak.authenticated) {
    keycloak.updateToken(50).then((refreshed) => {
      if (refreshed) {
        localStorage.setItem('token-idrc', keycloak.token)
      }
    })
  }
}

keycloak.onTokenExpired = () => updateKeycloakToken()

async function authenticateAgainstKeycloak () {
  await keycloak.init({ onLoad: 'check-sso', checkLoginIframe: false }).then((auth) => {
      if (keycloak.authenticated && keycloak.token) {
        window.localStorage.setItem('token-idrc', keycloak.token)
      } else {
        window.localStorage.removeItem('token-idrc')
      }
    })
    .catch(async (e) => {
      console.log(e)
      if (e.error === 'login_required') {
        await keycloak.login({ scope: '' })
      } else {
        console.log(e)
      }
    })
}

window.NProgress = NProgress
window.objSwal = objSwal
window.Swal = Swal

window.loader = (obj) => {
  obj.active ? NProgress.start() : NProgress.done()
  store.dispatch("auth/loader", obj).then(res => res)
}

window.refreshPage = () => {
  return router.push(window.location.pathname)
}

// Globaliza o Swal e simplifica as chamadas | Alerts.question() |  Alerts.info()
window.Alerts = alerts

function instantiateVueApp () {
  // Bootstrap uses
  Vue.use(BootstrapVue)

  // global components
  Vue.component('IconSvg', IconSvg)
  Vue.component('Multiselect', Multiselect)
  Vue.component('v-select', vSelect)
  Vue.component('modal-global', ModalGlobal)

  Vue.use(money, {precision: 4})

  Vue.config.productionTip = false
  Vue.use(AuthInterceptor, { router })
  Vue.use(VeeValidate, {
    locale: 'pt',
    fieldsBagName: 'veeFields',
    dictionary
  })

  Validator.extend('max_date', maxDate, {
    paramNames: ['max']
  })

  /* inicio - ripple */
  Vue.directive("ripple", Ripple)
  /* fim - ripple */

  Vue.use(VueInputMask)
  Vue.use(money, {precision: 4})
  Vue.directive("selected-option", selectedOption)
  Vue.filter('date', filterDate)
  Vue.filter('dateHour', filterDateHour)
  Vue.filter('Endereco', filterEndereco)
  Vue.filter('getPaisById', getPaisById)
  Vue.filter('uppercase', uppercaseFilterString)
  Vue.filter('lowercase', lowercaseFilterString)
  Vue.filter('moneyToString', moneyToString)
  Vue.filter('firstCapitalize', firstLetterCapitalize) //primeira letra em maiúsculo
  Vue.filter('estadoCivil', estadoCivilFilter) //primeira letra em maiúsculo
  Vue.filter('cpf', maskCPF) //pontuacao para cpf
  Vue.filter('cnpj', maskCNPJ)
  Vue.filter('maskMatricula', maskMatricula) //pontuacao para cpf
  Vue.filter('hour', filterHour) //hora e minutos

  Vue.directive('uppercase', upperCase)
  Vue.directive('zero-before', zeroBefore)
  Vue.directive('on-leaving-select', onLeavingSelect)


  window.app = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

// -----------------------------------------------------------------------------------

// // Bootstrap uses
// Vue.use(BootstrapVue)
//
// // global components
// Vue.component('IconSvg', IconSvg)
// Vue.component('Multiselect', Multiselect)
// Vue.component('v-select', vSelect)
// Vue.component('modal-global', ModalGlobal)
//
// Vue.use(money, {precision: 4})
//
// Vue.config.productionTip = false
// Vue.use(AuthInterceptor, { router })
// Vue.use(VeeValidate, {
//   locale: 'pt',
//   fieldsBagName: 'veeFields',
//   dictionary
// })
//
// Validator.extend('max_date', maxDate, {
//   paramNames: ['max']
// })

// -----------------------------------------------------------------------------------


// -----------------------------------------------------------------------------------
/* inicio - ripple */
// import Ripple from "vue-material-design-ripple"
// import "vue-material-design-ripple/dist/vue-material-design-ripple.css"
// //  import App from './App.vue'
//
// Vue.directive("ripple", Ripple)
// /* fim - ripple */
//
// Vue.use(VueInputMask)
// Vue.use(money, {precision: 4})
// Vue.directive("selected-option", selectedOption)
// Vue.filter('date', filterDate)
// Vue.filter('dateHour', filterDateHour)
// Vue.filter('Endereco', filterEndereco)
// Vue.filter('getPaisById', getPaisById)
// Vue.filter('uppercase', uppercaseFilterString)
// Vue.filter('lowercase', lowercaseFilterString)
// Vue.filter('moneyToString', moneyToString)
// Vue.filter('firstCapitalize', firstLetterCapitalize) //primeira letra em maiúsculo
// Vue.filter('estadoCivil', estadoCivilFilter) //primeira letra em maiúsculo
// Vue.filter('cpf', maskCPF) //pontuacao para cpf
// Vue.filter('maskMatricula', maskMatricula) //pontuacao para cpf
// Vue.filter('hour', filterHour) //hora e minutos
//
// Vue.directive('uppercase', upperCase)
// Vue.directive('zero-before', zeroBefore)
// Vue.directive('on-leaving-select', onLeavingSelect)
// ------------------------------------------------------------------------------------

//Ajustando v-select para aceitar pesquisa sem acento
vSelect.props.filterBy = {
  type: Function,
  default (option, label, search) {
    const control = search.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')

    if (search === control) {
      label = label.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    }

    return label.toLowerCase().indexOf(search.toLowerCase()) > -1
  }
}

router.beforeEach(pageControl)

/* modal GLOBAL */
window.modalGlobal = {
  show: (action, data = null) => {
    // action define qual tipo de modal aparecerá
    // data para caso o modal precise vir com dados já determinados
    window.app.$root.$emit('bv::show::modal', 'modal-global')

    // caso data não seja null
    // dispara um evento informando-a
    if ( action || data) window.app.$root.$emit('sofia::modalGlobal::data', { action, data })
  },
  hide: () => {
    window.app.$root.$emit('bv::hide::modal', 'modal-global')
  }
}

window.displayMessage = (type, title, text, options = null) => {
  objSwal[type].title = title

  if (options && options.useHtml) {
    objSwal[type].html = text
    delete objSwal[type].text
  } else {
    objSwal[type].text = text
    delete objSwal[type].html
  }

  if (options) {
    const swalOptions = Object.assign({}, options)

    delete swalOptions.useHtml

    Object.assign(objSwal[type], swalOptions)
  }

  return Swal.fire(objSwal[type]).then((res) => {
    objSwal[type].title = null
    objSwal[type].text = null
    objSwal[type].html = null

    return res
  })
}

// retornar dados no console
import SofiaDebug from '@/helpers/SofiaDebug'
window.dd = SofiaDebug

// authenticateAgainstKeycloak().then(() => {
  
// })

instantiateVueApp()
